export default {
  id: "pay",
  initial: "idle",
  states: {
    idle: {},
    forbidden: {
      initial: "toast",
      states: {
        toast: {
          after: {
            2000: "hidden"
          },
          meta: {
            message: "已达到购买上限"
          }
        },
        hidden: {
          always: "#appActivity.participate"
        }
      }
    },
    preCheck: {
      initial: "pending",
      states: {
        pending: {
          invoke: {
            id: "checkCoupon",
            src: "checkAllLuckCoupon",
            onDone: [
              {
                target: "unusedCoupon",
                actions: ["setUnusedCoupon", "queryMultiCouponSuccessReport"],
                cond: "hasUnusedCoupon"
              },
              // {
              //   cond: "isInMSDK",
              //   actions: ["queryMultiCouponSuccessReport"],
              //   target: "#pay.payDialog"
              // },
              {
                // cond: "IsInQQOrWechat",
                actions: ["queryMultiCouponSuccessReport"],
                target: "#pay.placeOrder"
              }
            ],
            onError: "failure"
          }
        },
        unusedCoupon: {
          entry: ["unUsedCouponReport"],
          meta: {
            message: "您还有宝箱未开启，先去开启宝箱吧~",
            btnText: "去开宝箱"
          },
          on: {
            CLOSE: "#appActivity.participate"
          }
        },
        failure: {
          entry: ["queryMultiCouponErrorReport"],
          initial: "visible",
          states: {
            visible: {
              after: {
                2000: "hidden"
              },
              meta: {
                message: "系统开小差了，请重新尝试~"
              }
            },
            hidden: {
              always: "#appActivity.participate"
            }
          }
        }
      }
    },
    payDialog: {
      on: {
        PAY: {
          actions: ["confirmPayReport"],
          target: "#pay.placeOrder"
        },
        CLOSE: "#appActivity.participate"
      }
    },
    placeOrder: {
      initial: "pending",
      states: {
        pending: {
          invoke: {
            id: "placeOrder",
            src: "placeOrder",
            onDone: {
              target: "success",
              actions: ["placeOrderSuccess"]
            },
            onError: {
              target: "failure"
            }
          }
        },
        success: {
          on: {
            PAY: "#pay.payment"
          }
        },
        failure: {
          entry: ["placeOrderReport"],
          initial: "visible",
          states: {
            visible: {
              after: {
                2000: "hidden"
              },
              meta: {
                message: "系统开小差了，请重新尝试~"
              }
            },
            hidden: {
              always: "#appActivity.participate"
            }
          }
        }
      }
    },
    payment: {
      initial: "pending",
      states: {
        pending: {
          invoke: {
            id: "midasPay",
            src: "midasPay",
            onDone: [
              {
                cond: "isBatchDraw",
                actions: ["updateTaskScore", "paySuccessReport"],
                target: "#luckydraw.batchDraw"
              },
              // {
              //   target: "newRound",
              //   actions: ["updateTaskScore", "paySuccessReport"],
              //   cond: "enterNewRound"
              // },
              {
                target: "autoDraw",
                actions: ["updateTaskScore", "paySuccessReport"]
              }
            ],
            onError: [
              // {
              //   cond: "insufficientBalance",
              //   actions: ["payErrorReport"],
              //   target: "failure.insufficientBalance"
              // },
              // {
              //   cond: "isInMSDK",
              //   actions: ["payErrorReport"],
              //   target: "failure.common"
              // },
              {
                target: "#appActivity.participate"
              }
            ]
          }
        },
        newRound: {
          initial: "visible",
          states: {
            visible: {
              after: {
                2000: "hidden"
              },
              meta: {
                message: "新的一圈开始咯~"
              }
            },
            hidden: {
              entry: ["drawAfterPay"]
            }
          }
        },
        autoDraw: {
          initial: "visible",
          states: {
            visible: {
              after: {
                2000: "hidden"
              },
              meta: {
                message: "宝箱即将自动开启……"
              }
            },
            hidden: {
              entry: ["drawAfterPay"]
            }
          }
        },
        failure: {
          states: {
            insufficientBalance: {
              on: {
                GO_RECHARGE: {
                  actions: ["jumpToRechargeScene"],
                  target: "#appActivity.participate"
                }
              },
              meta: {
                message: "当前余额不足，请先充值哦~",
                btnText: "去充值"
              }
            },
            common: {
              meta: {
                message: "系统繁忙，请稍候再试！"
              }
            }
          },
          on: {
            CLOSE: "#appActivity.participate"
          }
        }
      }
    }
  },
  on: {
    CLICK_PRESENT: [
      {
        target: "#luckydraw.showDrawDialog.first",
        actions: ["setSelectedPresentRank", "setAvailableOpenPresentRank", "clickPresentReport", "resetCouponNum"]
      }
      // {
      //   target: ".luckydraw.showPrizeList",
      //   cond: "hasnotReachedScore",
      //   actions: ["setSelectedPresentRank", "clickPresentReport"]
      // },
      // {
      //   target: ".luckydraw.showAward",
      //   cond: "hasFetchedDrawAward",
      //   actions: ["setSelectedPresentRank", "clickPresentReport"]
      // },
      // {
      //   target: ".luckydraw.receiveTaskPresent",
      //   cond: "hasnotReceivedtaskAward",
      //   actions: ["setSelectedPresentRank", "clickPresentReport"]
      // },
      // {
      //   target: ".luckydraw.getDrawCoupon",
      //   actions: ["setSelectedPresentRank", "clickPresentReport"]
      // }
    ]
  }
}
